"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KlassItem = void 0;
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const common_1 = require("../../../common");
const classes_1 = require("../../../server/classes");
const account_1 = require("../../base/account");
const action_1 = require("../../menu/action");
const function_1 = require("../../menu/function");
const common_2 = require("../common");
const ui_1 = require("../ui");
const DropDownInput_1 = require("../ui/DropDownInput");
const constant_1 = require("./constant");
const types_1 = require("./types");
const TeachersTable_1 = require("../common/TeachersTable");
const popup_1 = require("../../base/popup");
const DeletePopUpLayout_1 = require("../../base/layout/DeletePopUpLayout");
const react_i18next_1 = require("react-i18next");
exports.KlassItem = react_1.default.memo(({ id, isModify }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const user_id = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const [item, setItem] = react_1.default.useState(types_1.DEFAULT_KLASS_ITEM);
    const deleteKlassMutation = (0, react_query_1.useMutation)(classes_1.deleteKlassItem);
    const modifyKlassMutation = (0, react_query_1.useMutation)(classes_1.modifyKlassItem);
    const registKlassMutation = (0, react_query_1.useMutation)(classes_1.postKlassItem);
    const registKlassMenuMutation = (0, react_query_1.useMutation)(classes_1.postKlassMenu);
    // 사이트 명 중복 체크 여부
    const [isSiteNameCheck, setIsSiteNameCheck] = react_1.default.useState(id ? true : false);
    // 사이트명
    const [siteName, setSiteName] = react_1.default.useState('');
    // 클래스명
    const [title, setTitle] = react_1.default.useState('');
    // 과목명
    const [subject, setSubject] = react_1.default.useState('');
    // 시작일
    const [startDate, setStartDate] = react_1.default.useState('');
    // 종료일
    const [endDate, setEndDate] = react_1.default.useState('');
    // 상태
    const [status, setStatus] = react_1.default.useState('active');
    // 메뉴 숨김
    // 신규 등록(id 없음)은 DEFAULT_NEW_KLASS_HIDDEN_MENUS 로 시작한다 — 다시보기(학생)를
    // 기본 비노출로 두기 위함. 기존 클래스(id 있음)는 아래 useEffect 가 서버 값으로 덮는다.
    const [hiddenMenus, setHiddenMenus] = react_1.default.useState(() => id ? [] : [...constant_1.DEFAULT_NEW_KLASS_HIDDEN_MENUS]);
    // 강사 정보
    const [teacherItem, setTeacherItem] = react_1.default.useState(undefined);
    // 강사 아이디
    const [teacherId, setTeacherId] = react_1.default.useState("");
    const [key, setKey] = react_1.default.useState(0);
    // 관리자가 [메뉴 관리 > 학생] 체크박스를 직접 건드렸는지. 신규 등록 저장 시 기본 비노출을 강제할지 판단한다.
    // (폼 상태가 어떤 이유로든 초기화돼도 기본값이 유실되지 않게 하는 안전장치)
    const [isStudentMenuTouched, setIsStudentMenuTouched] = react_1.default.useState(false);
    const { data, refetch } = (0, classes_1.useClassesList)({ id, with_name: true });
    const refetchList = (0, lodash_1.throttle)(() => refetch(), 1000);
    const resetStates = () => {
        setKey(key + 1);
        setIsStudentMenuTouched(false);
        // 신규 등록 폼은 서버 값이 없으므로 초기 상태와 같은 기본 비노출 목록으로 되돌린다.
        // (등록 실패로 폼이 남는 경우 다시보기 체크가 임의로 켜지는 것을 막는다)
        setHiddenMenus(id
            ? (0, function_1.normalizeHiddenMenus)(item.hidden_menus || [])
            : [...constant_1.DEFAULT_NEW_KLASS_HIDDEN_MENUS]);
    };
    // (onClick) 취소 버튼 클릭 시 이전 페이지로 이동
    const cancelMenu = () => {
        if (id) {
            resetStates();
            refetchList();
        }
        dispatch((0, action_1.goToPrevMenu)());
    };
    // (onClick) 버튼 클릭 시 회사 정보 삭제
    const deleteAlert = () => {
        const handlerDelete = async () => {
            if (!id)
                return;
            APP.eventManager.publish('SHOW_LOADING', true);
            try {
                await deleteKlassMutation.mutateAsync(id);
                // 상세 페이지 - 수정 페이지로 이동
                APP.eventManager.publish('CHANGE_MENU', {
                    showDepth: 'list',
                    props: undefined,
                });
            }
            catch (error) {
                alert(error);
            }
            finally {
                APP.eventManager.publish('SHOW_LOADING', false);
            }
        };
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: t('assignment.delteInto', { count: 1 }),
                onDelete: handlerDelete,
            },
            width: 639,
            title: '클래스 삭제',
            isFit: true,
        });
    };
    // (onClick) 버튼 클릭 시 회사 정보 등록 및 수정
    const handlerSubmit = async () => {
        APP.eventManager.publish('SHOW_LOADING', true);
        try {
            const today = (0, moment_1.default)().startOf('day');
            const selectedEndDate = (0, moment_1.default)(endDate).startOf('day');
            if (status === "active") {
                if (!selectedEndDate.isAfter(today)) {
                    alert('종료일은 오늘 이후의 날짜여야 합니다.');
                    return;
                }
            }
            if (id) {
                if (isModify) {
                    if (item.identifier !== siteName && !isSiteNameCheck) {
                        alert('사이트명 중복 체크를 해주세요.');
                        return;
                    }
                    await modifyKlassMutation.mutateAsync({
                        class_id: id,
                        props: {
                            capacity: 1,
                            deadline: status === "active"
                                ? (0, moment_1.default)(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
                                : (0, moment_1.default)().endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
                            startline: (0, moment_1.default)(startDate)
                                .startOf('day')
                                .format('YYYY-MM-DDTHH:mm:ssZ'),
                            subject: subject,
                            title: title,
                            teacher_id: teacherId,
                        },
                    });
                    await registKlassMenuMutation.mutateAsync({
                        class_id: id,
                        props: {
                            menus: (0, function_1.normalizeHiddenMenus)(hiddenMenus, { dropUnknown: true }),
                        },
                    });
                    // 상세 페이지 - 수정 페이지로 이동
                    APP.eventManager.publish('CHANGE_MENU', {
                        showDepth: 'detail',
                        props: { id },
                    });
                }
                else {
                    // 상세 페이지 - 수정 페이지로 이동
                    APP.eventManager.publish('CHANGE_MENU', {
                        showDepth: 'modify',
                        props: { id },
                    });
                }
            }
            else {
                if (!isSiteNameCheck) {
                    alert('사이트명 중복 체크를 해주세요.');
                    return;
                }
                if (teacherItem === undefined) {
                    alert('강사를 선택해주세요.');
                    return;
                }
                const response = await registKlassMutation.mutateAsync({
                    capacity: 1,
                    deadline: status === "active"
                        ? (0, moment_1.default)(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
                        : (0, moment_1.default)().subtract(1, 'day').endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
                    startline: status === "active"
                        ? (0, moment_1.default)(startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
                        : (0, moment_1.default)().subtract(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
                    subject: subject,
                    title: title,
                    teacher_id: teacherItem?.id,
                    identifier: siteName,
                    tenant_id: teacherItem?.tenant_id,
                });
                const class_id = response.result.id;
                // 신규 등록: 관리자가 학생 메뉴를 직접 건드리지 않았다면 기본 비노출 목록을 반드시 포함시킨다.
                // (초기 폼 상태에도 들어 있지만, 저장 시점에 한 번 더 보장해 기본값 유실을 막는다)
                const menusToHide = (0, function_1.normalizeHiddenMenus)(isStudentMenuTouched
                    ? hiddenMenus
                    : [...hiddenMenus, ...constant_1.DEFAULT_NEW_KLASS_HIDDEN_MENUS], { dropUnknown: true });
                await registKlassMenuMutation.mutateAsync({
                    class_id: class_id,
                    props: { menus: menusToHide },
                });
                // 상세 페이지 - 수정 페이지로 이동
                APP.eventManager.publish('CHANGE_MENU', {
                    showDepth: 'list',
                    props: undefined,
                });
            }
        }
        catch (error) {
            alert(error);
        }
        finally {
            resetStates();
            refetchList();
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    react_1.default.useEffect(() => {
        id && refetchList();
    }, [id, key]);
    react_1.default.useEffect(() => {
        if (!id)
            return;
        setSiteName(item.identifier);
        setTitle(item.title);
        setSubject(item.subject);
        setStartDate(item.startline);
        setEndDate(item.deadline);
        setStatus(item.status);
        setHiddenMenus((0, function_1.normalizeHiddenMenus)(item.hidden_menus || []));
        setTeacherId(item.host);
        // setMemberIds(item.members);
    }, [item, id]);
    react_1.default.useEffect(() => {
        if (data && id) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                // 서버 total_count·items 불일치 응답(범위 밖 조회 등) — 단건 상세 폼에서
                // DEFAULT_KLASS_ITEM으로 리셋하면 수정 중인 폼이 빈 기본값으로 덮여
                // 그대로 저장 시 데이터 훼손 위험이 있으므로 기존 item 상태를 유지한다.
                return;
            }
            else {
                if (items.length > 0) {
                    const item = items[0];
                    setItem(item);
                    return;
                }
            }
        }
        setItem(types_1.DEFAULT_KLASS_ITEM);
    }, [data, key]);
    const defaultFirstDate = isModify ? (0, moment_1.default)().format('YYYY-MM-DD') : (0, moment_1.default)(item.startline).format('YYYY-MM-DD');
    const defaultSecondDate = isModify ?
        status === "active" ?
            id ? (0, moment_1.default)(item.deadline).format('YYYY-MM-DD') : (0, moment_1.default)().add(1, 'year').format('YYYY-MM-DD')
            : (0, moment_1.default)().format('YYYY-MM-DD') : (0, moment_1.default)(item.deadline).format('YYYY-MM-DD');
    return (react_1.default.createElement("div", { className: "regist_container" },
        react_1.default.createElement("div", { className: "regist_box_wrapper half" },
            react_1.default.createElement("div", { className: "regist_box" },
                react_1.default.createElement(ui_1.TextInput, { key: `classCode_${key}`, className: `${isModify && !id && siteName
                        ? isSiteNameCheck
                            ? 'ok'
                            : 'error'
                        : ''}`, title: "\uD074\uB798\uC2A4 \uCF54\uB4DC", defaultValue: item.identifier, handlerUpdate: (name) => {
                        setSiteName(name);
                        setIsSiteNameCheck(false);
                    }, disabled: !isModify || (isModify && id) ? true : false, noShowButtonArea: !isModify || id !== undefined, buttonOption: isModify &&
                        !id && {
                        title: '중복체크',
                        className: 'btn-semi-round btn-blue btn-xmd',
                        handlerClick: () => {
                            if (item.identifier === siteName) {
                                alert('사용 가능한 클래스 코드입니다.');
                                setIsSiteNameCheck(true);
                                return;
                            }
                            (0, classes_1.getClassesList)({ identifier: siteName }).then((response) => {
                                const { total_count, items, found_count } = response.result;
                                if (total_count > 0 && found_count > 0) {
                                    alert('이미 존재하는 사이트명입니다.');
                                    setIsSiteNameCheck(false);
                                }
                                else {
                                    alert('사용 가능한 클래스 코드입니다.');
                                    setIsSiteNameCheck(true);
                                }
                            });
                        },
                    } }),
                react_1.default.createElement(ui_1.TextInput, { key: `className_${key}`, title: "\uD074\uB798\uC2A4\uBA85", defaultValue: item.title, handlerUpdate: setTitle, disabled: !isModify, noShowButtonArea: !isModify || id !== undefined }),
                react_1.default.createElement(ui_1.TextInput, { key: `subject_${key}`, title: "\uACFC\uBAA9\uBA85", defaultValue: item.subject, handlerUpdate: setSubject, disabled: !isModify, noShowButtonArea: !isModify || id !== undefined }),
                react_1.default.createElement(ui_1.DurationDateInput, { key: `date_${key}`, type: "date", title: "\uAE30\uAC04 \uC124\uC815", defaultFirstValue: defaultFirstDate, defaultSecondValue: defaultSecondDate, handlerFirstUpdate: setStartDate, handlerSecondUpdate: setEndDate, firstDisabled: true, secondDisabled: !(isModify && status === "active"), noShowButtonArea: !isModify || id !== undefined, status: status }),
                react_1.default.createElement(DropDownInput_1.DropDownInput, { key: `status_${key}`, title: "\uC0C1\uD0DC", disabled: !isModify, noShowButtonArea: !isModify || id !== undefined, noSelectOption: {
                        show: false,
                        id: null,
                        title: '선택 안함',
                    }, defaultValue: item.status, handlerUpdate: setStatus, dropdownList: [
                        {
                            id: 'active',
                            value: '사용',
                        },
                        {
                            id: 'inactive',
                            value: '미사용',
                        },
                    ] }),
                react_1.default.createElement("div", { className: 'hidden_menu_input' },
                    react_1.default.createElement("label", { className: 'title' }, "\uBA54\uB274 \uAD00\uB9AC"),
                    react_1.default.createElement("div", { className: 'hidden_menus_wrap' },
                        react_1.default.createElement(ui_1.CheckboxInput, { key: `common_${key}`, className: "hidden_menus", title: "\uACF5\uD1B5", disabled: !isModify, noShowButtonArea: !isModify || id !== undefined, defaultValues: constant_1.COMMON_MENU_LIST.filter(menu => !hiddenMenus.includes(menu.id)).map(menu => menu.id), handlerUpdate: (selectedMenus) => {
                                const commonHidden = constant_1.COMMON_MENU_LIST.filter(menu => !selectedMenus.includes(menu.id)).map(menu => menu.id);
                                const teacherHidden = constant_1.TEACHER_MENU_LIST.filter(menu => hiddenMenus.includes(menu.id)).map(menu => menu.id);
                                const studentHidden = constant_1.STUDENT_MENU_LIST.filter(menu => hiddenMenus.includes(menu.id)).map(menu => menu.id);
                                setHiddenMenus((0, function_1.normalizeHiddenMenus)([...commonHidden, ...teacherHidden, ...studentHidden], { dropUnknown: true }));
                            }, options: constant_1.COMMON_MENU_LIST }),
                        react_1.default.createElement(ui_1.CheckboxInput, { key: `teacher_${key}`, className: "hidden_menus", title: "\uAC15\uC0AC", disabled: !isModify, noShowButtonArea: !isModify || id !== undefined, defaultValues: constant_1.TEACHER_MENU_LIST.filter(menu => !hiddenMenus.includes(menu.id)).map(menu => menu.id), handlerUpdate: (selectedMenus) => {
                                const teacherHidden = constant_1.TEACHER_MENU_LIST.filter(menu => !selectedMenus.includes(menu.id)).map(menu => menu.id);
                                const commonHidden = constant_1.COMMON_MENU_LIST.filter(menu => hiddenMenus.includes(menu.id)).map(menu => menu.id);
                                const studentHidden = constant_1.STUDENT_MENU_LIST.filter(menu => hiddenMenus.includes(menu.id)).map(menu => menu.id);
                                setHiddenMenus((0, function_1.normalizeHiddenMenus)([...commonHidden, ...teacherHidden, ...studentHidden], { dropUnknown: true }));
                            }, options: constant_1.TEACHER_MENU_LIST }),
                        react_1.default.createElement(ui_1.CheckboxInput, { key: `student_${key}`, className: "hidden_menus", title: "\uD559\uC0DD", disabled: !isModify, noShowButtonArea: !isModify || id !== undefined, defaultValues: constant_1.STUDENT_MENU_LIST.filter(menu => !hiddenMenus.includes(menu.id)).map(menu => menu.id), handlerUpdate: (selectedMenus) => {
                                setIsStudentMenuTouched(true);
                                const studentHidden = constant_1.STUDENT_MENU_LIST.filter(menu => !selectedMenus.includes(menu.id)).map(menu => menu.id);
                                const commonHidden = constant_1.COMMON_MENU_LIST.filter(menu => hiddenMenus.includes(menu.id)).map(menu => menu.id);
                                const teacherHidden = constant_1.TEACHER_MENU_LIST.filter(menu => hiddenMenus.includes(menu.id)).map(menu => menu.id);
                                setHiddenMenus((0, function_1.normalizeHiddenMenus)([...commonHidden, ...teacherHidden, ...studentHidden], { dropUnknown: true }));
                            }, options: constant_1.STUDENT_MENU_LIST }))),
                react_1.default.createElement("div", { className: "btn-container", style: { width: '100%' } },
                    !!id && !isModify && (react_1.default.createElement(common_1.Button, { text: "\uC0AD\uC81C", className: "btn-default-round btn-peach btn-xmd", onClick: deleteAlert })),
                    react_1.default.createElement(common_1.Button, { text: !id ? '등록' : '수정', className: "btn-default-round btn-blue btn-xmd", onClick: handlerSubmit }),
                    react_1.default.createElement(common_1.Button, { text: "\uCDE8\uC18C", className: "btn-default-round btn-grey btn-xmd", onClick: cancelMenu }))),
            react_1.default.createElement("div", { className: "regist_box", style: { gap: 12 } }, id ? (react_1.default.createElement(common_2.MembersTable, { id: id, isPopup: false, isModify: isModify, defaultValues: [...item.managers, ...item.members] })) : (react_1.default.createElement(TeachersTable_1.TeachersTable, { isPopup: false, isModify: isModify, setTeacherItem: setTeacherItem }))))));
});
